import { Link } from "@tanstack/react-router";
import {
  Blocks,
  Building2,
  ChevronRight,
  PanelLeft,
  Settings,
  ShieldCheck,
  UserRound,
} from "lucide-react";
import { TitleToolbar } from "@core/components/TitleToolbar";
import { getSettingsItems } from "@core/settings/settings-registry";

const iconMap = { Blocks, Building2, PanelLeft, ShieldCheck, UserRound };

export function SettingsIndexPage() {
  return (
    <div className="settings-index">
      <TitleToolbar
        density="compact"
        title="Configure VenPro"
        icon={Settings}
      />
      <div className="settings-list-card">
        {getSettingsItems().map((item) => {
          const Icon = iconMap[item.icon] ?? Settings;
          return (
            <Link key={item.id} to={item.path} className="settings-list-row">
              <span className="settings-list-icon"><Icon aria-hidden="true" /></span>
              <span>
                <strong>{item.label}</strong>
                <small>{item.description}</small>
              </span>
              <ChevronRight aria-hidden="true" />
            </Link>
          );
        })}
      </div>
    </div>
  );
}
